export const PHOTO_ALBUM_MAX_WIDTH = 1000;
export const PHOTO_ALBUM_THUMBS_WIDTH = 88;
export const PHOTO_ALBUM_VERTICAL_PADDING = 96; // MiniOverlay's pv6 * 2
export const PHOTO_ALBUM_CATEGORIES_HEIGHT = 72;
export const EXPLORE_PHOTO_ALBUM_CAPTION_HEIGHT = 64;
